import React, { memo } from 'react'
import './index.scss'

// tags
interface ITags {
  /** id */
  id: number | string;
  /** 名称 */
  name: string;
  /** 类型 */
  type: string;
  /** 颜色 */
  style?: string;
}

// props
interface IProps {
  /** 数据 */
  datas: ITags[];
  /** 能否打包 */
  disableTogo?: boolean;
  /** 能否单独售卖 */
  disableSingleSale?: boolean;
  /** 起售份数 */
  salesCnt?: number;
}

const Tags: React.FC<IProps> = ({ datas, disableTogo, disableSingleSale, salesCnt }) => {
  // 没有标签
  if (!datas?.length && !disableTogo && !disableSingleSale && !salesCnt) {
    return null
  }

  return (
    <div className='tags-list'>
      {datas?.map((item: ITags, index: number) => (
        <div className={'tag-item ' + item.type} style={item.style ? { color: item.style, border: `1px solid ${item.style}`, background: 'transparent' } : {}} key={item.id ?? `${item.type}${index}`} data-key={item.id ?? `${item.type}${index}`}>
          <div className='tag-text'>{item.name}</div>
        </div>
      ))}
      {
        disableTogo && (
          <div className='tag-item togo'>
            <div className='tag-text'>{i18n.t('menu.canNotTogo')}</div>
          </div>
        )
      }
      {
        disableSingleSale && (
          <div className='tag-item single-sale'>
            <div className='tag-text'>{i18n.t('menu.canNotSingleSale')}</div>
          </div>
        )
      }
      {
        !!salesCnt && salesCnt > 1 && (
          <div className='tag-item sales-cnt'>
            <div className='tag-text'>{i18n.t('menu.salesCntTag', { cnt: salesCnt || 1 })}</div>
          </div>
        )
      }
    </div>
  )
}

export default memo(Tags)
